import * as React from 'react';
import { type ApiEnrichStatus, useEnrichStatus } from '../../lib/enrich.js';

export interface EnrichScope {
  workspaceId: string | undefined;
  status: ApiEnrichStatus | null;
}

const EnrichScopeContext = React.createContext<EnrichScope>({
  workspaceId: undefined,
  status: null,
});

export function EnrichScopeProvider({
  workspaceId,
  children,
}: { workspaceId: string | undefined; children: React.ReactNode }) {
  const statusQuery = useEnrichStatus(workspaceId);
  const value = React.useMemo(
    () => ({ workspaceId, status: statusQuery.data ?? null }),
    [workspaceId, statusQuery.data],
  );
  return <EnrichScopeContext.Provider value={value}>{children}</EnrichScopeContext.Provider>;
}

/** Outside a provider: no workspace and no status, so cells show values only. */
export function useEnrichScope(): EnrichScope {
  return React.useContext(EnrichScopeContext);
}
